export default "__VITE_ASSET__BDQv5v7E__"